<template>
  <div class="main">
    <div class="title">
      <div class="name">专家领域</div>
      <div class="btn" @click="centerDialogVisible = true, id = '',ruleForm.name = ''">领域添加</div>
    </div>
    <div class="listbox">
      <el-table
          :data="tableData"
          border
          :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
          :cell-style="{'text-align':'center'}"
          style="width: 100%;border-radius: 10px;">
        <el-table-column
            prop="name"
            label="领域"
            width="450">
        </el-table-column>
        <el-table-column
            prop="create_time"
            label="添加时间"
            width="280">
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <el-button
                size="small"
                class="del"
                round
                disabled
                v-if="Number(scope.row.delBtn) === 0">删除</el-button>
            <el-button
                size="small"
                class="del"
                round
                v-else
                @click="handleDelete(scope.row.id)">删除</el-button>
            <el-button
                size="small"
                type="primary"
                class="edit"
                round
                @click="centerDialogVisible = true, id = scope.row.id, ruleForm.name = scope.row.name">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        :visible.sync="centerDialogVisible"
        width="400px"
        custom-class="field"
        center>
      <div slot="title" class="titleDialog">
        {{id === '' ? '添加领域' : '编辑领域'}}
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-position="top">
          <el-form-item label="领域名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
            class=""
            @click="centerDialogVisible = false"
            round >取 消</el-button>
        <el-button type="primary" round @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {field, fieldDel, fieldlist} from "@/api/index";
// import {zhDate} from '@/utils/utils'
export default {
  name: "field",
  data() {
    return {
      id:'',
      centerDialogVisible: false,
      ruleForm:{
        name:''
      },
      rules: {
        name: [
          {required: true, message: '请输入领域名称', trigger: 'blur'}
        ],
      },
      tableData: []
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 1,
      act: 0,
      name: '专家管理 > 专家领域'
    })
    this.list()
  },
  methods: {

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Field()
        } else {
          this.$message.error('请填写！');
          return false;
        }
      });
    },

    handleDelete(id) {
      this.id = id
      this.$confirm('此操作将删除该领域，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.del()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    // 删除
    async del(){
      let _res = await fieldDel(
          this.user.mid,
          this.id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.list()
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 添加 编辑
    async Field() {
      let _res = await field(
          this.user.mid,
          this.ruleForm.name,
          this.id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.centerDialogVisible = false
        this.list()
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 领域列表
    async list() {
      let _res = await fieldlist(
          this.user.mid,
          1,
          999
      );
      if (_res.status === 200) {
        this.tableData = _res.data
      } else {
        this.$message.error(_res.msg)
      }
    }


  },
  watch: {
    id(){
      console.log(this.id)
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">

.titleDialog {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}
.dialog-footer button {
  width: 120px;
  height: 40px;
  border-radius: 20px;
  padding: 0;
  line-height: 40px;
  margin: 0 30px;
}
.del {
  width: 70px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px #0a2240;
  line-height: 28px;
  padding: 0;
  color: #0a2240;
}
.edit {
  width: 70px;
  height: 30px;
  background-color: #0a2240;
  line-height: 30px;
  padding: 0;
  border-radius: 15px;
}
.main {
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
    .btn {
      width: 120px;
      height: 40px;
      background-color: #ff9600;
      border-radius: 20px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
  }
  .listbox {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 15px;
    min-height: 600px;
    flex: 1;
  }
}
</style>


